// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2 6.50017L2 17.5002L9.91421 17.5002L15.4142 12.0002L9.91421 6.50017L2 6.50017ZM14.5858 7.50015L19.0858 12.0002L14.5858 16.5001L16 17.9144L21.9142 12.0002L16 6.08594L14.5858 7.50015Z"}}]};

const ComponentBreadcrumbFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'component-breadcrumb-filled',
    ref,
    icon: element,
  },
));

ComponentBreadcrumbFilledIcon.displayName = 'ComponentBreadcrumbFilledIcon';

export default ComponentBreadcrumbFilledIcon;
